/**
 * Dynamic inner slider (slider.php): same Swiper behaviour as modules/modules-hero/slider/slider.js
 * (.slider.slider-bleed-wrap + .pagination-wrapper). Only runs inside .slider.
 */
(function () {
	'use strict';

	function syncCaptionToggleTabOrder(swiperEl) {
		swiperEl.querySelectorAll('.swiper-slide .caption-toggle').forEach(function (toggleEl) {
			var slideEl = toggleEl.closest('.swiper-slide');
			var isActive = slideEl && slideEl.classList.contains('swiper-slide-active');
			toggleEl.setAttribute('tabindex', isActive ? '0' : '-1');
		});
	}

	function initCaptionToggles(scope) {
		scope.querySelectorAll('.swiper-slide .caption-toggle').forEach(function (toggleEl) {
			var slideEl = toggleEl.closest('.swiper-slide');
			var captionEl = slideEl ? slideEl.querySelector('figcaption') : null;

			if (!slideEl || !captionEl) return;

			captionEl.style.display = 'none';
			toggleEl.setAttribute('role', 'button');
			toggleEl.setAttribute('tabindex', '-1');
			toggleEl.setAttribute('aria-expanded', 'false');
			toggleEl.setAttribute('aria-label', 'Show caption');

			function toggleCaption() {
				var isOpen = captionEl.style.display !== 'none';
				captionEl.style.display = isOpen ? 'none' : 'block';
				toggleEl.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				toggleEl.setAttribute('aria-label', isOpen ? 'Show caption' : 'Hide caption');
			}

			toggleEl.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				toggleCaption();
			});

			toggleEl.addEventListener('keydown', function (event) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					toggleCaption();
				}
			});
		});
	}

	function init() {
		if (typeof Swiper === 'undefined') return;

		document.querySelectorAll('.slider .slider-swiper').forEach(function (swiperEl) {
			var root = swiperEl.closest('.slider');
			if (!root) return;
			initCaptionToggles(root);

			var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
			if (!slideCount) return;

			var paginationWrap = root.querySelector('.pagination-wrapper');
			var paginationEl = paginationWrap ? paginationWrap.querySelector('.swiper-pagination') : null;
			var nextEl = paginationWrap ? paginationWrap.querySelector('.swiper-button-next') : null;
			var prevEl = paginationWrap ? paginationWrap.querySelector('.swiper-button-prev') : null;

			var config = {
				direction: 'horizontal',
				loop: false,
				slidesPerView: '1',
				spaceBetween: 24,
				slidesPerGroup: 1,
				speed: 700,
				centeredSlides: false,
				watchOverflow: true,
				breakpoints: {
					0: { slidesPerView: '1' },
					576: { slidesPerView: '1' },
					992: { slidesPerView: '1' },
				},
			};

			if (paginationEl) {
				config.pagination = { el: paginationEl, clickable: true };
			}
			if (nextEl && prevEl) {
				config.navigation = { nextEl: nextEl, prevEl: prevEl };
			}

			var swiper = new Swiper(swiperEl, config);
			syncCaptionToggleTabOrder(swiperEl);

			swiper.on('slideChange', function () {
				syncCaptionToggleTabOrder(swiperEl);
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
